module.exports = __webpack_public_path__ + "img/RX-Arcos-4-zoom.dd7c71b3.png";